module.exports = __webpack_public_path__ + "img/TinyTAN_Permission_to_Dance_01.dbcc912c.png";